import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Paper,
  useMediaQuery
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { Fragment, useEffect, useState } from 'react'
import {
  PickingRoute,
  SelectedZone,
  UserZone
} from '../../../interfaces/Picking/Picking'
import WarningIcon from '@mui/icons-material/Warning'
import HowToVoteIcon from '@mui/icons-material/HowToVote'
import { useStyles } from '../styles'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'
import PickingTypeSelect from './PickingTypeSelect'
import { useApi } from '../../../hooks/useApi'
import { Loading } from '../../UI'
import { Status } from '../../../hooks/useFetchState'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { ZoneSelect } from './PickingSelectZone'
import CustomAlert from '../../_WMS/AlertMessage/AlertMessage'
import { useUser } from '../../../hooks/useUser'
interface PickingStartProps {
  pickingRoute: PickingRoute | undefined
  handleFetchProduct: any
  handleGenerateRoute: any
  onChangeTypePickingRoute: (type: eTypePickingRoute) => void
  selectedPickingType: eTypePickingRoute
  selectedZoneId: number
  setSelectedZoneId: (id: number) => void
}

export const PickingStart: React.FC<PickingStartProps> = ({
  pickingRoute,
  handleFetchProduct,
  handleGenerateRoute,
  selectedPickingType,
  onChangeTypePickingRoute,
  selectedZoneId,
  setSelectedZoneId
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // true si está en celular

  const {
    userDataState: { userData },
    getUserData
  } = useUser()

  const [isEditingZone, setIsEditingZone] = useState(false)
  const { state, callApi } = useApi<UserZone[]>()

  const getUserZone = (userId: number) => {
    const url = new URL(`${ApiConfig.UserApi}/${userId}/zones`)

    return axios.get(url.toString())
  }

  const PrefixNameStorage: string = 'userSelectedZone_'

  useEffect(() => {
    if (!userData) {
      getUserData()
    }
  }, [])

  const requestGetUserZone = () => {
    callApi(getUserZone(userData?.userId || (0 as number)))
      .then((data) => {
        const key = `${PrefixNameStorage}${userData?.userId || 0}`
        const storedZoneJson = localStorage.getItem(key)

        if (storedZoneJson) {
          try {
            const parsed: SelectedZone = JSON.parse(storedZoneJson)
            const zoneIdNumber = parsed.selectedZoneId
            // Verifica si el zoneId almacenado sigue siendo válido
            const existsInList = (data as UserZone[]).some(
              (z) => z.zoneId === zoneIdNumber
            )

            setSelectedZoneId(existsInList ? zoneIdNumber : data[0].zoneId)
          } catch {
            setSelectedZoneId(data[0].zoneId)
          }
        } else {
          setSelectedZoneId(data[0].zoneId)
        }
      })
      .catch()
  }

  useEffect(() => {
    requestGetUserZone()
  }, [])

  if (state.status === Status.Loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Grid
        container
        direction='column'
        justifyContent='flex-start'
        alignItems='center'
        spacing={2}
      >
        {' '}
        {!pickingRoute && (
          <Grid item xs={12} style={{ width: '50%' }}>
            <PickingTypeSelect
              selectedType={selectedPickingType}
              onChange={(value) => onChangeTypePickingRoute(value)}
            />
          </Grid>
        )}
        {!state.data ? (
          <CustomAlert
            severity='warning'
            message={state.error}
            maxWidth={'50%'}
          ></CustomAlert>
        ) : (
          <Fragment>
            <ZoneSelect
              zones={state.data || []}
              isEditingZone={isEditingZone}
              userId={userData?.userId || 0}
              prefixNameStorage={PrefixNameStorage}
              selectedZoneId={selectedZoneId}
              setSelectedZoneId={setSelectedZoneId}
              setIsEditingZone={setIsEditingZone}
              isMobile={isMobile}
            />
            <Grid container justifyContent='center'>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 15
                }}
              >
                {pickingRoute ? (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleFetchProduct}
                    disabled={isEditingZone}
                    fullWidth={isMobile}
                    style={!isMobile ? { width: 200 } : {}}
                  >
                    Continuar pickings
                  </Button>
                ) : (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleGenerateRoute}
                    disabled={isEditingZone}
                    fullWidth={isMobile}
                    style={
                      isMobile
                        ? { minHeight: 37, fontSize: '1.1rem' } // más alto y letra un poco más grande
                        : { width: 200 }
                    }
                  >
                    Iniciar nuevo picking
                  </Button>
                )}
              </Grid>
            </Grid>
          </Fragment>
        )}
        {!pickingRoute && (
          <Grid item xs={12} style={{ marginTop: 60 }}>
            <Paper elevation={0} className={classes.paper}>
              <List className={classes.alert}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <WarningIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary='No hay rutas de picking asignadas'
                    secondary=''
                  />
                </ListItem>
              </List>
            </Paper>
          </Grid>
        )}
        {pickingRoute && (
          <Grid item xs={12}>
            <Paper elevation={0} className={classes.paper}>
              <List className={classes.alert}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <HowToVoteIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={'Ruta de Picking'}
                    secondary={
                      pickingRoute.typePickingRouteId === eTypePickingRoute.RTV
                        ? `#RTV${pickingRoute.pickingRouteId}`
                        : `#${pickingRoute.pickingRouteId}`
                    }
                  />
                </ListItem>
              </List>
            </Paper>
          </Grid>
        )}
        <Grid
          container
          direction='column'
          alignItems='center'
          justifyContent='center'
        >
          <Grid item xs={12}>
            <Typography variant='h4' component='h4'>
              {userData?.userName || 'sin información'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}
